{
    "description":  "Tracks the project version and when it was last bumped. This file is committed to git history. The \u0027timestamp\u0027 field records when the version was changed, not when the code was built.",
    "timestamp":  "20251125222303",
    "version":  "1.3.19",
    "buildMode":  "quick"
}